var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBox = function SvgBox(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 36.821486,954.38477 c -0.236,0.011 -0.46997,0.064 -0.6875,0.1563 l -34.9999998,16 c -1.12510001,0.5121 -1.39273001,2.15 -0.68750001,3.125 L 11.321486,986.38473 0.44648619,999.07223 c -0.65445,0.9192 -0.4376,2.61277 0.68750001,3.12507 l 10.8437498,4.9688 0,25.201 c 0.006,0.7633 0.49004,1.5024 1.1875,1.8125 l 35.968746,16 c 0.50969,0.2266 1.1153,0.2266 1.625,0 l 36.03125,-16 c 0.69745,-0.3101 1.1817,-1.0492 1.1875,-1.8125 l 0,-25.201 10.84375,-4.9688 c 1.12509,-0.5123 1.493758,-2.188 0.6875,-3.12507 l -10.875,-12.6875 10.875,-12.71866 c 0.806258,-0.9371 0.43759,-2.6129 -0.6875,-3.125 l -35,-16 c -0.31271,-0.1362 -0.66065,-0.1906 -1,-0.1563 -0.49463,0.036 -0.97284,0.2637 -1.3125,0.625 l -11.53125,12.4063 -11.531246,-12.4063 c -0.41075,-0.4379 -1.02664,-0.6748 -1.625,-0.625 z m -0.3125,4.4063 10.093746,10.875 -32.062496,14.28116 -9.3124998,-10.84366 z m 26.937496,0 31.28125,14.3125 -9.3125,10.84366 -32.0625,-14.28116 z m -13.46875,13.7812 31.0625,13.81246 -31.0625,13.78127 -31.062496,-13.78127 z m -35.437496,16.21876 32.062496,14.28127 -10.093746,10.875 -31.2812498,-14.31257 z m 70.874996,0 9.3125,10.8437 -31.28125,14.31257 -10.09375,-10.875 z m -37.4375,18.68757 0,37.7947 -31.999996,-14.2187 0,-22.076 20.15625,9.2187 c 0.76431,0.3513 1.74529,0.1525 2.3125,-0.4687 z m 4,0 9.53125,10.25 c 0.5672,0.6212 1.54818,0.82 2.3125,0.4687 l 20.15625,-9.2187 0,22.076 -32,14.1875 z",
    style: {
      textIndent: 0,
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      baselineShift: "baseline",
      color: "#000000",
      enableBackground: "accumulate"
    },
    fill: "#8E959B",
    fillOpacity: 1,
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/box.537faa7f.svg";
export { ForwardRef as ReactComponent };